import React from 'react';
import { FaExclamationTriangle as TriangleAlert } from 'react-icons/fa';
import { LuSearch as Search } from 'react-icons/lu';

import {
  historyDate,
  historyEye,
  historyOpMR,
  historyRowKey,
  historyValue
} from './historyHelpers';
import { DATE_INPUT_MAX, DATE_INPUT_MIN, normalizeDateInputValue } from './formPrimitives';

function ModalNotice({ tone, icon, children }) {
  return (
    <div className={`lens-notice lens-notice-${tone}`}>
      {icon}
      <span className="lens-notice-text">{children}</span>
    </div>
  );
}

function ModalActionButton({ label, icon, onClick, primary, disabled, type = 'button' }) {
  return (
    <button
      className={`lens-action-button ${primary ? 'lens-primary-button' : 'lens-secondary-button'}`}
      type={type}
      onClick={onClick}
      disabled={disabled}
    >
      {icon}
      <span className={primary ? 'lens-primary-text' : ''}>{label}</span>
    </button>
  );
}

export default function HistoryLookupModal({
  query,
  rows,
  selectedRow,
  loading,
  error,
  onClose,
  onQueryChange,
  onPeriodClick,
  onSearch,
  onSelect,
  onApply
}) {
  const handleSubmit = (event) => {
    event.preventDefault();
    onSearch();
  };

  return (
    <div className="lens-history-modal-backdrop" role="presentation" onMouseDown={onClose}>
      <section
        className="lens-history-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="lens-history-modal-title"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <header className="lens-history-modal-header">
          <div>
            <p className="lens-history-modal-kicker">PATIENT HISTORY</p>
            <h2 id="lens-history-modal-title">검사 이력 조회</h2>
          </div>
          <button className="lens-history-close-button" type="button" aria-label="검사 이력 조회 닫기" onClick={onClose}>×</button>
        </header>

        <form className="lens-history-search-form" onSubmit={handleSubmit}>
          <label className="lens-history-query-field lens-history-chart-field">
            <span>차트번호</span>
            <input value={query.chartNo} onChange={(event) => onQueryChange('chartNo', event.target.value)} placeholder="차트번호 입력" autoFocus />
          </label>
          <label className="lens-history-query-field">
            <span>시작일</span>
            <input
              type="date"
              value={query.startDt}
              min={DATE_INPUT_MIN}
              max={DATE_INPUT_MAX}
              onChange={(event) => onQueryChange('startDt', normalizeDateInputValue(event.target.value))}
            />
          </label>
          <label className="lens-history-query-field">
            <span>종료일</span>
            <input
              type="date"
              value={query.endDt}
              min={DATE_INPUT_MIN}
              max={DATE_INPUT_MAX}
              onChange={(event) => onQueryChange('endDt', normalizeDateInputValue(event.target.value))}
            />
          </label>
          {/* <div className="lens-history-period-actions" aria-label="빠른 기간 설정">
            <button type="button" onClick={() => onPeriodClick(1)}>1개월</button>
            <button type="button" onClick={() => onPeriodClick(3)}>3개월</button>
            <button type="button" onClick={() => onPeriodClick(6)}>6개월</button>
          </div> */}
          <ModalActionButton label={loading ? '조회 중' : '조회'} icon={<Search size={16} color="#ffffff" />} type="submit" primary disabled={loading} />
        </form>

        {error ? <ModalNotice tone="bad" icon={<TriangleAlert size={15} color="#b91c1c" />}>{error}</ModalNotice> : null}

        <div className="lens-history-result-area">
          <div className="lens-history-result-heading">
            <h3>검사 이력</h3>
            {rows.length ? <span>{rows.length}건</span> : null}
          </div>
          {loading ? <div className="lens-history-loading"><div className="lens-loading" /><span>검사 이력을 불러오는 중입니다.</span></div> : null}
          {!loading && rows.length ? (
            <div className="lens-history-list" role="list">
              {rows.map((row, index) => {
                const selected = selectedRow === row;
                return (
                  <button
                    className={`lens-history-row${selected ? ' lens-history-row-selected' : ''}`}
                    key={historyRowKey(row, index)}
                    type="button"
                    role="listitem"
                    onClick={() => onSelect(row)}
                  >
                    <span className="lens-history-row-date">{historyDate(row)}</span>
                    <span className="lens-history-row-eye">{historyEye(row)}</span>
                    <span className="lens-history-row-value">OPMR {historyOpMR(row)}</span>
                    <span className="lens-history-row-value">ACD {historyValue(row, ['acd_preop', 'acdPreop', 'acd'])}</span>
                    <span className="lens-history-row-value">WTW {historyValue(row, ['wtw', 'WTW'])}</span>
                  </button>
                );
              })}
            </div>
          ) : null}
          {!loading && !rows.length && !error ? <p className="lens-history-empty">차트번호와 조회기간을 입력한 뒤 조회하세요.</p> : null}
        </div>

        <footer className="lens-history-modal-footer">
          <p>{selectedRow ? `${historyDate(selectedRow)} · ${historyEye(selectedRow)} 검사 이력이 선택되었습니다.` : '불러올 검사 이력 1건을 선택하세요.'}</p>
          <div className="lens-actions">
            <ModalActionButton label="취소" onClick={onClose} />
            <ModalActionButton label="검사값 불러오기" onClick={onApply} primary disabled={!selectedRow || loading} />
          </div>
        </footer>
      </section>
    </div>
  );
}
